import _regeneratorRuntime from "babel-runtime/regenerator";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Grid, TextField, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import profileStyles from '../jss/ProfileStyles';
import defaultAvatar from '../../assets/img/default-avatar.png';
import ImageUpload from '../common/components/ImageUpload';

var App = function (_Component) {
    _inherits(App, _Component);

    function App() {
        var _ref,
            _this2 = this;

        var _temp, _this, _ret;

        _classCallCheck(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            data: _this.props.data || null,
            error: null
        }, _this.handleChange = function (e) {
            var onChange = _this.props.onChange;

            var data = Object.assign({}, _this.state.data);
            data[e.target.name] = e.target.value;

            // let error = {...this.state.error}

            // if(e.target.value && e.target.name === 'fb' && !this.validateURL(e.target.value)) {
            //     error.fb = true
            // }else {
            //     delete error.fb
            // }
            // if(e.target.value && e.target.name === 'instagram' && !this.validateURL(e.target.value)) {
            //     error.instagram = true
            // }else {
            //     delete error.instagram
            // }
            // if(e.target.value && e.target.name === 'twitter' && !this.validateURL(e.target.value)) {
            //     error.twitter = true
            // }else {
            //     delete error.twitter
            // }
            // if(e.target.value && e.target.name === 'webLink' && !this.validateURL(e.target.value)) {
            //     error.webLink = true
            // }else {
            //     delete error.webLink
            // }
            // if(e.target.value && e.target.name === 'linkedin' && !this.validateURL(e.target.value)) {
            //     error.linkedin = true
            // }else {
            //     delete error.linkedin
            // }
            // this.setState({error})

            _this.setState({ data: data });
            onChange(data);
        }, _this.getBase64 = function (file) {
            return new Promise(function (resolve) {
                var baseURL = "";
                var reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = function () {
                    baseURL = reader.result;
                    resolve(baseURL);
                };
            });
        }, _this.handleCompanyImageChange = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                var file, data;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.getBase64(e.target.files[0]);

                            case 2:
                                file = _context.sent;
                                data = Object.assign({}, _this.state.data);

                                data.avatar = file;
                                _this.setState({ data: data });

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }(), _this.handleRemoveCompanyImage = function () {
            var data = Object.assign({}, _this.state.data);
            data.avatar = '';
            _this.setState({ data: data });
        }, _this.handleSubmit = function (e) {
            e.preventDefault();
            var handleSave = _this.props.handleSave;
            var error = _this.state.error;

            if (_this.isEmpty(error)) {
                handleSave();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(App, [{
        key: "validateURL",
        value: function validateURL(url) {
            var re = new RegExp(/((ftp|http|https):\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*)/);
            return re.test(String(url).toLowerCase());
        }
    }, {
        key: "isEmpty",
        value: function isEmpty(obj) {
            return Object.keys(obj).length === 0;
        }
    }, {
        key: "render",
        value: function render() {
            var classes = this.props.classes;
            var _state = this.state,
                _state$data = _state.data,
                avatar = _state$data.avatar,
                address = _state$data.address,
                fb = _state$data.fb,
                firstName = _state$data.firstName,
                headline = _state$data.headline,
                instagram = _state$data.instagram,
                lastName = _state$data.lastName,
                linkedin = _state$data.linkedin,
                professionalSummary = _state$data.professionalSummary,
                twitter = _state$data.twitter,
                webLink = _state$data.webLink,
                error = _state.error;

            console.log(error);
            return React.createElement(
                "div",
                { className: classes.container },
                React.createElement(
                    "div",
                    { className: classes.formContainer },
                    React.createElement(
                        "form",
                        { onSubmit: this.handleSubmit },
                        React.createElement(
                            Grid,
                            { container: true, justify: "center", spacing: 16 },
                            React.createElement(
                                Grid,
                                { item: true, mg: 12, sm: 12, style: { marginBottom: '20px' } },
                                React.createElement(ImageUpload, { imageSrc: avatar, handleImageChange: this.handleCompanyImageChange, handleRemoveImage: this.handleRemoveCompanyImage })
                            ),
                            React.createElement(
                                Grid,
                                { item: true, mg: 3, sm: 6, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "First Name"
                                ),
                                React.createElement("input", { type: "text", name: "firstName", onChange: this.handleChange, value: firstName, placeholder: "First Name", maxLength: "38" })
                            ),
                            React.createElement(
                                Grid,
                                { item: true, mg: 3, sm: 6, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "Last Name"
                                ),
                                React.createElement("input", { type: "text", name: "lastName", onChange: this.handleChange, value: lastName, placeholder: "Last Name", maxLength: "38" })
                            ),
                            React.createElement(
                                Grid,
                                { item: true, md: 12, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "Headline"
                                ),
                                React.createElement("input", { type: "text", name: "headline", onChange: this.handleChange, value: headline, placeholder: "Headline", maxLength: "60" })
                            ),
                            React.createElement(
                                Grid,
                                { item: true, md: 12, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "Professional Summary"
                                ),
                                React.createElement("textarea", { name: "professionalSummary", value: professionalSummary, maxLength: "1500", onChange: this.handleChange, placeholder: "Professional Summary" })
                            ),
                            React.createElement(
                                Grid,
                                { item: true, md: 6, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "Address"
                                ),
                                React.createElement("input", { type: "text", name: "address", onChange: this.handleChange, value: address, placeholder: "Address", maxLength: "80" })
                            ),
                            React.createElement(
                                Grid,
                                { item: true, md: 6, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "Website Link"
                                ),
                                React.createElement("input", { type: "text", name: "webLink", onChange: this.handleChange, value: webLink, placeholder: "Website Link", style: { border: error && error.webLink ? '1px solid red' : '' } }),
                                error && error.webLink && React.createElement(
                                    "p",
                                    null,
                                    "Must be a valid url"
                                )
                            ),
                            React.createElement(
                                Grid,
                                { item: true, md: 6, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "Facebook"
                                ),
                                React.createElement("input", { type: "text", name: "fb", onChange: this.handleChange, value: fb, placeholder: "Facebook", style: { border: error && error.fb ? '1px solid red' : '' } }),
                                error && error.fb && React.createElement(
                                    "p",
                                    null,
                                    "Must be a valid url"
                                )
                            ),
                            React.createElement(
                                Grid,
                                { item: true, md: 6, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "Linkedin"
                                ),
                                React.createElement("input", { type: "text", name: "linkedin", onChange: this.handleChange, value: linkedin, placeholder: "Linkedin", style: { border: error && error.linkedin ? '1px solid red' : '' } }),
                                error && error.linkedin && React.createElement(
                                    "p",
                                    null,
                                    "Must be a valid url"
                                )
                            ),
                            React.createElement(
                                Grid,
                                { item: true, md: 6, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "Instagram"
                                ),
                                React.createElement("input", { type: "text", name: "instagram", onChange: this.handleChange, value: instagram, placeholder: "Instagram", style: { border: error && error.instagram ? '1px solid red' : '' } }),
                                error && error.instagram && React.createElement(
                                    "p",
                                    null,
                                    "Must be a valid url"
                                )
                            ),
                            React.createElement(
                                Grid,
                                { item: true, md: 6, xs: 12, className: classes.formItem },
                                React.createElement(
                                    "label",
                                    null,
                                    "Twitter"
                                ),
                                React.createElement("input", { type: "text", name: "twitter", onChange: this.handleChange, value: twitter, placeholder: "Twitter", style: { border: error && error.twitter ? '1px solid red' : '' } }),
                                error && error.twitter && React.createElement(
                                    "p",
                                    null,
                                    "Must be a valid url"
                                )
                            ),
                            React.createElement(
                                Grid,
                                { item: true, md: 12, sm: 12 },
                                React.createElement(
                                    Button
                                    // disabled={isSubmitting}
                                    ,
                                    { style: { background: 'rgb(88, 80, 236)', color: '#fff' },
                                        size: "large",
                                        type: "submit",
                                        variant: "contained"
                                    },
                                    "Save"
                                )
                            )
                        )
                    )
                ),
                React.createElement(
                    "div",
                    { className: classes.profileWrapper },
                    React.createElement(
                        "div",
                        { className: classes.profileContainer },
                        React.createElement(
                            "div",
                            { className: classes.profileIconWrapper },
                            React.createElement("img", { src: avatar || defaultAvatar, alt: "profile", className: classes.profileIcon })
                        ),
                        React.createElement(
                            "div",
                            { className: classes.contentWrapper },
                            React.createElement(
                                "h2",
                                null,
                                firstName + ' ' + lastName
                            ),
                            React.createElement(
                                "p",
                                { className: classes.summary },
                                headline
                            ),
                            React.createElement(
                                "a",
                                { href: webLink, className: classes.link },
                                webLink
                            ),
                            React.createElement(
                                "p",
                                null,
                                address
                            ),
                            professionalSummary && React.createElement("div", { className: classes.line }),
                            professionalSummary && React.createElement(
                                "h3",
                                null,
                                "About"
                            ),
                            React.createElement("div", { className: classes.about,
                                dangerouslySetInnerHTML: { __html: professionalSummary.replace(/\n/g, "<br />") }
                            }),
                            React.createElement("div", { className: classes.line }),
                            React.createElement(
                                "div",
                                { className: classes.experience },
                                React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h3",
                                        null,
                                        "Work"
                                    ),
                                    React.createElement(
                                        "p",
                                        null,
                                        "Sequoia Labs Initiative"
                                    )
                                ),
                                React.createElement(
                                    "div",
                                    null,
                                    React.createElement(
                                        "h3",
                                        null,
                                        "Education"
                                    ),
                                    React.createElement(
                                        "p",
                                        null,
                                        "Harvard University"
                                    )
                                )
                            ),
                            React.createElement(
                                "div",
                                { className: classes.socialContainer },
                                fb && React.createElement(
                                    "a",
                                    { href: fb },
                                    React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MC43NzMiIGhlaWdodD0iNDAuNzczIiB2aWV3Qm94PSIwIDAgNDAuNzczIDQwLjc3MyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzNiNTk5ODt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik00MC43NzMsMjAuMzg3QTIwLjM4NywyMC4zODcsMCwxLDAsMjAuMzg3LDQwLjc3M2MuMTE5LDAsLjIzOSwwLC4zNTgtLjAwOFYyNC45aC00LjM4VjE5LjhoNC4zOFYxNi4wMzhjMC00LjM1NiwyLjY2LTYuNzI5LDYuNTQ2LTYuNzI5YTM1LjU3OSwzNS41NzksMCwwLDEsMy45MjYuMnY0LjU1NUgyOC41NDFjLTIuMTEsMC0yLjUyNCwxLTIuNTI0LDIuNDc3djMuMjQ5aDUuMDU3bC0uNjYxLDUuMWgtNC40VjM5Ljk4NUEyMC4zOTMsMjAuMzkzLDAsMCwwLDQwLjc3MywyMC4zODdaIi8+PC9zdmc+", alt: "facebook" })
                                ),
                                linkedin && React.createElement(
                                    "a",
                                    { href: linkedin },
                                    React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MC43NzMiIGhlaWdodD0iNDAuNzczIiB2aWV3Qm94PSIwIDAgNDAuNzczIDQwLjc3MyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzBlNzZhODt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0yMC4zODcsMEEyMC4zODcsMjAuMzg3LDAsMSwwLDQwLjc3MywyMC4zODcsMjAuMzg5LDIwLjM4OSwwLDAsMCwyMC4zODcsMFpNMTQuNDYzLDMwLjgxOUg5LjVWMTUuODgxaDQuOTY1Wk0xMS45OCwxMy44NDJoLS4wMzJhMi41ODgsMi41ODgsMCwxLDEsLjA2NS01LjE2MSwyLjU4OSwyLjU4OSwwLDEsMS0uMDMzLDUuMTYxWk0zMi4zNjYsMzAuODE5SDI3LjRWMjIuODI4YzAtMi4wMDgtLjcxOS0zLjM3OC0yLjUxNS0zLjM3OGEyLjcxOCwyLjcxOCwwLDAsMC0yLjU0NywxLjgxNiwzLjQsMy40LDAsMCwwLS4xNjMsMS4yMTJ2OC4zNDJIMTcuMjFzLjA2NS0xMy41MzYsMC0xNC45MzdoNC45NjVWMThhNC45MjksNC45MjksMCwwLDEsNC40NzUtMi40NjZjMy4yNjcsMCw1LjcxNiwyLjEzNSw1LjcxNiw2LjcyM1ptMCwwIi8+PC9zdmc+", alt: "linkedin" })
                                ),
                                instagram && React.createElement(
                                    "a",
                                    { href: instagram },
                                    React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDAuNzczIiBoZWlnaHQ9IjQwLjc3MyIgdmlld0JveD0iMCAwIDQwLjc3MyA0MC43NzMiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOnVybCgjYSk7fTwvc3R5bGU+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iMS43NzUiIHkxPSItMC44NTMiIHgyPSIwLjExNSIgeTI9IjEuNjM2IiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjOGQzOGMxIi8+PHN0b3Agb2Zmc2V0PSIwLjIxNyIgc3RvcC1jb2xvcj0iI2M2MmE3NiIvPjxzdG9wIG9mZnNldD0iMC40OTgiIHN0b3AtY29sb3I9IiNkNzJiNzQiLz48c3RvcCBvZmZzZXQ9IjAuNzU0IiBzdG9wLWNvbG9yPSIjZjU2YzJmIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjZmRjODY2Ii8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0yMTQuOCwyMTAuOWEzLjksMy45LDAsMSwxLTMuOS0zLjlBMy45LDMuOSwwLDAsMSwyMTQuOCwyMTAuOVptMCwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTkwLjUxNSAtMTkwLjUxNikiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTE1NC4yMDcsMTM4LjE4MWEzLjg3NywzLjg3NywwLDAsMC0yLjIyMi0yLjIyMiw2LjQ3Nyw2LjQ3NywwLDAsMC0yLjE3My0uNGMtMS4yMzUtLjA1Ni0xLjYtLjA2OC00LjczMS0uMDY4cy0zLjUuMDEyLTQuNzMxLjA2OGE2LjQ4MSw2LjQ4MSwwLDAsMC0yLjE3My40LDMuODc4LDMuODc4LDAsMCwwLTIuMjIyLDIuMjIyLDYuNDc5LDYuNDc5LDAsMCwwLS40LDIuMTc0Yy0uMDU2LDEuMjM0LS4wNjgsMS42LS4wNjgsNC43MzFzLjAxMiwzLjUuMDY4LDQuNzMxYTYuNDc2LDYuNDc2LDAsMCwwLC40LDIuMTczLDMuODc3LDMuODc3LDAsMCwwLDIuMjIyLDIuMjIyLDYuNDY5LDYuNDY5LDAsMCwwLDIuMTc0LjRjMS4yMzQuMDU2LDEuNi4wNjgsNC43My4wNjhzMy41LS4wMTIsNC43MzEtLjA2OGE2LjQ2OCw2LjQ2OCwwLDAsMCwyLjE3NC0uNCwzLjg3NywzLjg3NywwLDAsMCwyLjIyMi0yLjIyMiw2LjQ4NCw2LjQ4NCwwLDAsMCwuNC0yLjE3M2MuMDU2LTEuMjM1LjA2OC0xLjYuMDY4LTQuNzMxcy0uMDEyLTMuNS0uMDY4LTQuNzMxQTYuNDcsNi40NywwLDAsMCwxNTQuMjA3LDEzOC4xODFaTTE0NS4wODIsMTUxLjFhNi4wMTEsNi4wMTEsMCwxLDEsNi4wMTEtNi4wMTFBNi4wMTEsNi4wMTEsMCwwLDEsMTQ1LjA4MiwxNTEuMVptNi4yNDktMTAuODU1YTEuNCwxLjQsMCwxLDEsMS40LTEuNEExLjQsMS40LDAsMCwxLDE1MS4zMzEsMTQwLjI0MVptMCwwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI0LjY5NSAtMTI0LjY5OSkiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTIwLjM4NywwQTIwLjM4NywyMC4zODcsMCwxLDAsNDAuNzczLDIwLjM4NywyMC4zODksMjAuMzg5LDAsMCwwLDIwLjM4NywwWk0zMi4wMjIsMjUuMjEzYTguNTg5LDguNTg5LDAsMCwxLS41NDQsMi44NDIsNS45ODYsNS45ODYsMCwwLDEtMy40MjQsMy40MjQsOC42LDguNiwwLDAsMS0yLjg0MS41NDRjLTEuMjQ4LjA1Ny0xLjY0Ny4wNzEtNC44MjYuMDcxcy0zLjU3OC0uMDE0LTQuODI3LS4wNzFhOC42LDguNiwwLDAsMS0yLjg0MS0uNTQ0QTUuOTg2LDUuOTg2LDAsMCwxLDkuMywyOC4wNTRhOC41ODcsOC41ODcsMCwwLDEtLjU0NC0yLjg0MWMtLjA1OC0xLjI0OS0uMDcxLTEuNjQ3LS4wNzEtNC44MjdzLjAxMy0zLjU3OC4wNzEtNC44MjZhOC41ODksOC41ODksMCwwLDEsLjU0NC0yLjg0Miw1Ljk5LDUuOTksMCwwLDEsMy40MjQtMy40MjQsOC42LDguNiwwLDAsMSwyLjg0Mi0uNTQ0YzEuMjQ4LS4wNTcsMS42NDctLjA3MSw0LjgyNi0uMDcxczMuNTc4LjAxNCw0LjgyNi4wNzFhOC42LDguNiwwLDAsMSwyLjg0Mi41NDMsNS45ODcsNS45ODcsMCwwLDEsMy40MjQsMy40MjQsOC41ODgsOC41ODgsMCwwLDEsLjU0NCwyLjg0MmMuMDU3LDEuMjQ4LjA3LDEuNjQ3LjA3LDQuODI2UzMyLjA4LDIzLjk2NCwzMi4wMjIsMjUuMjEzWm0wLDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDApIi8+PC9zdmc+", alt: "instagram" })
                                ),
                                twitter && React.createElement(
                                    "a",
                                    { href: twitter },
                                    React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MC43NzMiIGhlaWdodD0iNDAuNzczIiB2aWV3Qm94PSIwIDAgNDAuNzczIDQwLjc3MyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzFkYTFmMjt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0yMC4zODcsMEEyMC4zODcsMjAuMzg3LDAsMSwwLDQwLjc3MywyMC4zODcsMjAuMzg5LDIwLjM4OSwwLDAsMCwyMC4zODcsMFptOS4zMDgsMTUuOXEuMDE0LjMuMDEzLjZBMTMuMjIzLDEzLjIyMywwLDAsMSwxNi4zOTUsMjkuODE0aDBhMTMuMjQ1LDEzLjI0NSwwLDAsMS03LjE3Mi0yLjEsOS41MTgsOS41MTgsMCwwLDAsMS4xMTYuMDY1LDkuMzg5LDkuMzg5LDAsMCwwLDUuODEyLTIsNC42ODUsNC42ODUsMCwwLDEtNC4zNzItMy4yNSw0LjY2NCw0LjY2NCwwLDAsMCwyLjExMy0uMDgsNC42OCw0LjY4LDAsMCwxLTMuNzU0LTQuNTg3YzAtLjAyMSwwLS4wNCwwLS4wNmE0LjY0Nyw0LjY0NywwLDAsMCwyLjExOS41ODUsNC42ODMsNC42ODMsMCwwLDEtMS40NDktNi4yNDcsMTMuMjg1LDEzLjI4NSwwLDAsMCw5LjY0NSw0Ljg4OSw0LjY4Miw0LjY4MiwwLDAsMSw3Ljk3NC00LjI2N0E5LjM4NSw5LjM4NSwwLDAsMCwzMS40LDExLjYyMWE0LjcsNC43LDAsMCwxLTIuMDU4LDIuNTg4LDkuMzMzLDkuMzMzLDAsMCwwLDIuNjg3LS43MzdBOS41MDksOS41MDksMCwwLDEsMjkuNjk1LDE1LjlabTAsMCIvPjwvc3ZnPg==", alt: "twitter" })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return App;
}(Component);

export default withStyles(profileStyles)(App);


// WEBPACK FOOTER //
// ./node_modules/@int/profile_v1/lib/containers/App.js